export default __webpack_public_path__ + "static/ai-marketing-4--mobile-da41a2783725b66f312a3bd07ce863bf.png";